export default __webpack_public_path__ + "static/highlight-text-d88bbd5987a126e68edb1a1ab0db0c13.svg";